import list from 'src/modules/countryState/list/countryStateListReducers';
import form from 'src/modules/countryState/form/countryStateFormReducers';
import view from 'src/modules/countryState/view/countryStateViewReducers';
import destroy from 'src/modules/countryState/destroy/countryStateDestroyReducers';
import importerReducer from 'src/modules/countryState/importer/countryStateImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
